import { SESSION_STORAGE_AUTH_KEY } from '../Common/constants';
import menues from '../menu-items';
import _ from 'lodash';
import { logOut } from '../api';

const initialState = menues;
const recentCustomer = {
	id: 'recent_profile',
	title: 'Links',
	type: 'group',
	children: [
		{
			id: 'recent_profile',
			title: 'Recent Deployments',
			type: 'item',
			url: '/',
			icon: 'feather icon-shuffle',
			action: 'DASHBOARD',
		},
	]
};

let updatedState = {};

export default function menuReducer(state = initialState, action) {

	const logOutUser = async () => {
		try {
			await logOut();
		} catch (error) {
			console.log(error);
		}
	}

	switch (action.type) {
		case 'DASHBOARD':
			updatedState = _.cloneDeep(state);
			if (updatedState.items[1].id === 'equipments' || updatedState.items[1].id === 'recent_profile') {
				updatedState.items.splice(1, 1);
			}
		return updatedState;

		case 'CUSTOMER':
			updatedState = _.cloneDeep(state);
			if (updatedState.items[1].id !== 'recent_profile') {
				if (recentCustomer.children.length > 2) {
					recentCustomer.children.splice(0, 2);
				}
				updatedState.items.splice(1, 0, recentCustomer);
			}
		return updatedState;

		case 'LOG OUT':
			logOutUser();
			sessionStorage.setItem(SESSION_STORAGE_AUTH_KEY, false);
		return state;

		default:
		return state;
	}
}
